import React, { useEffect, useState } from "react";
import NotesContainerWithSubject from "../Notes/NotesContainerWithSubject";
import { collection, query, where, orderBy, limit, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";
import { CircularProgress } from "@mui/material";

function PsychoEdNotesContainerMobile(props) {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const notesRef = collection(db, "notes");
    const q = query(
      notesRef,
      where("noteType", "==", "psychoEdNote"),
      ...(props.clientId ? [where("clientId", "==", props.clientId)] : []),
      orderBy("effectiveDateTime", "desc"),
      limit(50)
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const notesData = [];
      querySnapshot.forEach((doc) => {
        notesData.push({ id: doc.id, ...doc.data() });
      });
      setNotes(notesData);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [props.clientId]);

  return (
    <div className="notes-container-global">
      {loading ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
          <p>Loading, please wait...</p>
        </div>
      ) : (
        notes.map((note) => {
          const dateOptions = {
            day: "numeric",
            month: "short",
            year: "numeric",
          };

          const timeOptions = {
            hour: "2-digit",
            minute: "2-digit",
          };

          const formattedDate = note.effectiveDateTime
            ? new Intl.DateTimeFormat("en-EN", dateOptions).format(
                note.effectiveDateTime.toDate()
              )
            : "";

          const formattedTime = note.effectiveDateTime
            ? new Intl.DateTimeFormat("en-EN", timeOptions).format(
                note.effectiveDateTime.toDate()
              )
            : "";

          return (
            <div style={{ paddingBottom: "15px" }} key={note.id}>
              <NotesContainerWithSubject
                noteContent={note.noteContent}
                effectiveDate={note.effectiveDateTime}
                noteDate={formattedDate}
                noteTime={formattedTime}
                doneBy={note.doneBy}
                timeStamp={formattedDate}
                noteId={note.id}
                {...note}
              />
            </div>
          );
        })
      )}
    </div>
  );
}

export default PsychoEdNotesContainerMobile;
